/**
 * 관리자 대시보드 요약 API.
 */
import api from './index'

/** GET /api/v1/dashboard — 카드·금일 목록·시세(7일)·최근 문의 */
export function getDashboard() {
  return api.get('/api/v1/dashboard')
}
